import { ScalingSquaresSpinner } from "epic-spinners";
export default {
  name: "LoadingMessage",
  components: {
    ScalingSquaresSpinner: ScalingSquaresSpinner
  },
  props: {
    loadingMessage: {
      type: String,
      default: ""
    }
  }
};